import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * Dentrix Ascend partner configuration schema
 * Defines the form fields for Dentrix Ascend integration agents
 */
export const dentrixAscendSchema: PartnerSchemaInternal = {
  partner: 'dentrix_ascend' as PartnerEnum,
  displayName: 'Dentrix Ascend',
  fields: [
    {
      key: 'organization_id',
      label: 'Organization ID',
      type: 'text',
      required: true,
      placeholder: 'org_12345',
      helperText: 'The unique identifier for your Dentrix Ascend organization',
    },
  ],
}
